import { Fragment } from 'react';
import styled from 'styled-components';

import checklist2x from '@wecasa/common/src/assets/images/checklist@2x.png';
import checklist3x from '@wecasa/common/src/assets/images/checklist@3x.png';
import checklist from '@wecasa/common/src/assets/images/checklist.png';
import heartRelax2x from '@wecasa/common/src/assets/images/heart-relax@2x.png';
import heartRelax3x from '@wecasa/common/src/assets/images/heart-relax@3x.png';
import heartRelax from '@wecasa/common/src/assets/images/heart-relax.png';
import piggyBank2x from '@wecasa/common/src/assets/images/piggy-bank@2x.png';
import piggyBank3x from '@wecasa/common/src/assets/images/piggy-bank@3x.png';
import piggyBank from '@wecasa/common/src/assets/images/piggy-bank.png';

import { translate } from '@wecasa/i18n';

import Alert from '@wecasa/web-ui/src/components/alert/alert';
import type { ImageProps } from '@wecasa/web-ui/src/components/image/image';
import Modal, { ModalContent } from '@wecasa/web-ui/src/components/modal/modal';
import Separator from '@wecasa/web-ui/src/components/separator/separator';
import StickerItem from '@wecasa/web-ui/src/components/sticker-item/sticker-item';
import { useIsMobile } from '@wecasa/web-ui/src/styles/media-queries';

const t = translate('screens.instant_tax_credit_selection.what_is_instant_tax_credit_modal');

type ImageItem = Pick<ImageProps, 'src' | 'double' | 'triple'> & { name: string };

const images: ImageItem[] = [
  {
    name: 'you_pay_only_half',
    src: piggyBank,
    double: piggyBank2x,
    triple: piggyBank3x,
  },
  {
    name: 'eligibility_is_simple',
    src: checklist,
    double: checklist2x,
    triple: checklist3x,
  },
  {
    name: 'in_practice',
    src: heartRelax,
    double: heartRelax2x,
    triple: heartRelax3x,
  },
];

const StyledModalContent = styled(ModalContent)`
  display: flex;
  flex-direction: column;
`;

const StyledAlert = styled(Alert)`
  margin-top: 20px;
`;

const Column = styled.div<{ $hasSmallGap: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $hasSmallGap }) => ($hasSmallGap ? '10px' : '25px')};
  padding-top: ${({ $hasSmallGap }) => ($hasSmallGap ? '10px' : '25px')};
`;

type WhatIsInstantTaxCreditModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const WhatIsInstantTaxCreditModal = ({ isOpen, onClose }: WhatIsInstantTaxCreditModalProps) => {
  const isMobile = useIsMobile();

  return (
    <Modal
      title={t('.title')}
      isOpen={isOpen}
      onClose={onClose}
      primaryButton={{
        children: t('base.got_it'),
        onPress: onClose,
      }}
    >
      <StyledModalContent>
        <Column $hasSmallGap={isMobile}>
          {images.map(({ name, src, double, triple }) => (
            <Fragment key={name}>
              <StickerItem
                alt={t(`.items.${name}.image_alt`)}
                src={src}
                double={double}
                triple={triple}
                title={t(`.items.${name}.title`)}
                text={t(`.items.${name}.content`)}
              />
              <Separator />
            </Fragment>
          ))}
        </Column>
        <StyledAlert type='info' content={t('.alert')} />
      </StyledModalContent>
    </Modal>
  );
};

export default WhatIsInstantTaxCreditModal;
